import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="isLoading" class="inset-0 z-50 flex items-center justify-center pointer-events-auto scale-125">
      <div class="relative">
        <!-- Outer Ring -->
        <div class="w-16 h-16 border-4 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
        <!-- Inner Ring with delay for effect -->
        <div class="w-16 h-16 border-4 border-gray-500 border-t-transparent rounded-full animate-spin absolute top-0 left-0" style="animation-delay: -0.4s"></div>
      </div>
    </div>
  `
})
export class SpinnerComponent {
  @Input() isLoading = false;
}
